import { render, staticRenderFns } from "./TableBeautyBodyImage.vue?vue&type=template&id=5bbfd72e&scoped=true"
import script from "./TableBeautyBodyImage.vue?vue&type=script&lang=js"
export * from "./TableBeautyBodyImage.vue?vue&type=script&lang=js"
import style0 from "./TableBeautyBodyImage.vue?vue&type=style&index=0&id=5bbfd72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbfd72e",
  null
  
)

export default component.exports